import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    CloseOutlined,
    CheckOutlined,
    UserOutlined,
    IdcardOutlined, EyeOutlined, SafetyOutlined, DatabaseOutlined, FileSearchOutlined, GlobalOutlined
} from "@ant-design/icons";

import { Card, Table, Typography, Tag, Button, Modal, Col, Row, Space, Divider, Avatar } from 'antd';
import React, { useState, useEffect, useCallback } from 'react';
import { ShowToast, Severty } from '../helper/toast';
import useRequest from '../hooks/useRequest';

import moment from 'moment';
const { Text, Title } = Typography;

const PERMISSION_ICONS = {
    View: <EyeOutlined />,
    Create: <PlusOutlined />,
    Edit: <EditOutlined />,
    Delete: <DeleteOutlined />,
};



const SurfaceCard = ({ children, bg, border }) => (
    <Card
        bordered={false}
        style={{
            height: "100%",
            borderRadius: 20,
            background: bg,
            border,
            boxShadow: "0 12px 30px rgba(0,0,0,.06)",
        }}
    >
        {children}
    </Card>
);

const InfoItem = ({ icon, label, value }) => (
    <div
        style={{
            display: "flex",
            gap: 12,
            alignItems: "flex-start",
            marginBottom: 14,
        }}
    >
        <span
            style={{
                color: "#8c8c8c",
                fontSize: 16,
                marginTop: 2,
            }}
        >
            {icon}
        </span>

        <div>
            <Text type="secondary" style={{ fontSize: 13 }}>
                {label}
            </Text>
            <div style={{ fontWeight: 500 }}>{value || "N/A"}</div>
        </div>
    </div>
);

const SectionTitle = ({ icon, title }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 18, color: "#1677ff" }}>{icon}</span>
        <Title level={5} style={{ margin: 0 }}>
            {title}
        </Title>
    </div>
);

function AuditLogsManager() {
    const [auditLogs, setAuditLogs] = useState([]);
    const [selectedAuditLog, setSelectedAuditLog] = useState(null);
    const [viewModal, setViewModal] = useState(false);
    const [selectedModules, setSelectedModules] = useState({});
    const [roleModalVisible, setRoleModalVisible] = useState(false);
    const { request } = useRequest();
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
    });

    const fetchAuditLogs = useCallback(() => {
        const params = new URLSearchParams();
        params.append("page", pagination.current);
        params.append("limit", pagination.pageSize);
        request({
            url: `/api/admin/audit-logs?${params.toString()}`,
            method: "GET",
            onSuccess: (res) => {
                setAuditLogs(res.data || []);
                setPagination((prev) => ({
                    ...prev,
                    total: res.pagination.total || 0,
                }));
            },
            onError: (error) => {
                ShowToast(error.message, Severty.ERROR);
            },
        });
    }, [pagination.current, pagination.pageSize]);

    useEffect(() => {
        fetchAuditLogs();
    }, [fetchAuditLogs]);

    const ACTION_COLORS = {
        CREATE: "green",
        UPDATE: "blue",
        DELETE: "red",

        LOGIN: "cyan",
        LOGOUT: "volcano",

        APPROVE: "green",
        REJECT: "red",

        BLOCK: "red",
        UNBLOCK: "green",

        TRANSFER: "purple",
        DEPOSIT: "green",
        WITHDRAWAL: "orange",

        CREDIT: "green",
        DEBIT: "red",

        ASSIGN: "blue",
        REMOVE: "volcano",

        VERIFY: "geekblue",

        SEND: "cyan",
        CANCEL: "red",

        ACTIVATE: "green",
        DEACTIVATE: "volcano",

        PASSWORD_CHANGE: "gold",
        PIN_CHANGE: "gold",

        SESSION_TERMINATE: "magenta",

        STATUS_CHANGE: "processing", // antd special status color
        SUBSCRIBE: "lime",

        SYSTEM: "default",
    };

    // useEffect(() => {
    //     if (!roleModalVisible) {
    //         // setRoleModalVisible(false);
    //         // setSelectedModules({});
    //     }
    // }, [roleModalVisible]);
    const AuditLogsColumn = [
        {
            title: "Admin ID",
            dataIndex: "id",
            render: (text) => <Text code>{text ?? "N/A"}</Text>,
        },
        {
            title: "Done By",
            dataIndex: "actor_name",
        },
        {
            title: "Type",
            dataIndex: "actor_type",
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (text) => <Tag color={ACTION_COLORS[text.toUpperCase()]}>{text}</Tag>,
        },
        {
            title: "View",
            render: (_, record) => (
                <Button
                    className="button-action-small"
                    onClick={() => {
                        setSelectedAuditLog(record);
                        setViewModal(true);
                    }}
                >
                    <EyeOutlined />
                </Button>
            )
        }


    ]

    return (
        <div>
            <Card
                title={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12,
                        }}
                    >
                        <span>
                            <IdcardOutlined /> Audit Logs Manager
                        </span>
                    </div>
                }

            >
                <Table
                    dataSource={auditLogs}
                    columns={AuditLogsColumn}
                    pagination={pagination}
                    onChange={(pager) => {
                        setPagination((prev) => ({
                            ...prev,
                            current: pager.current,
                            pageSize: pager.pageSize,
                        }));
                    }} />
            </Card>
            {/* VIEW DETAILS MODAL */}
            <Modal
                open={viewModal}
                onCancel={() => setViewModal(false)}
                footer={null}
                width="70vw"
                centered
                destroyOnClose
                styles={{
                    content: {
                        padding: 0,
                        borderRadius: 24,
                        overflow: "hidden",
                        background: "#f5f7fb",
                    },
                }}
            >
                {selectedAuditLog && (
                    <>
                        {/* ===== HEADER ===== */}
                        <div
                            style={{
                                padding: "16px 20px",
                                background: "linear-gradient(135deg, #eef3ff 0%, #f9fcff 100%)",
                                borderBottom: "1px solid #e4ebf5",
                            }}
                        >
                            <Row justify="space-between" align="middle">
                                <Col>
                                    <Title level={3} style={{ margin: 0 }}>
                                        <IdcardOutlined style={{ marginRight: 10 }} />
                                        Audit Log #{selectedAuditLog.id}
                                    </Title>

                                    <Space style={{ marginTop: 8 }}>
                                        <Tag color="blue">{selectedAuditLog.actor_type}</Tag>
                                        <Tag
                                            color={
                                                ACTION_COLORS[selectedAuditLog.action.toUpperCase()]
                                            }
                                        >
                                            {selectedAuditLog.action}
                                        </Tag>
                                    </Space>
                                </Col>
                            </Row>
                        </div>

                        {/* ===== CONTENT ===== */}
                        <div style={{ padding: 16 }}>
                            <Row gutter={[24, 24]}>
                                {/* ACTOR INFO */}
                                <Col span={24} md={12}>
                                    <SurfaceCard
                                        bg="linear-gradient(135deg, #f0f9ff, #e6fffb)"
                                        border="1px solid #cceeff"
                                    >
                                        <SectionTitle
                                            icon={<UserOutlined />}
                                            title="Actor Details"
                                        />
                                        <Divider />

                                        <InfoItem
                                            icon={<UserOutlined />}
                                            label="Performed By"
                                            value={selectedAuditLog.actor_name}
                                        />

                                        <InfoItem
                                            icon={<SafetyOutlined />}
                                            label="Actor Type"
                                            value={
                                                <Tag color="blue">
                                                    {selectedAuditLog.actor_type}
                                                </Tag>
                                            }
                                        />
                                    </SurfaceCard>
                                </Col>

                                {/* RESOURCE INFO */}
                                <Col span={24} md={12}>
                                    <SurfaceCard
                                        bg="linear-gradient(135deg, #fff7e6, #fff1f0)"
                                        border="1px solid #ffd8bf"
                                    >
                                        <SectionTitle
                                            icon={<DatabaseOutlined />}
                                            title="Resource Details"
                                        />
                                        <Divider />

                                        <InfoItem
                                            label="Resource Type"
                                            value={selectedAuditLog.resource_type}
                                        />

                                        {selectedAuditLog?.resource_id && <InfoItem
                                            label="Resource ID"
                                            value={
                                                <Text code>
                                                    {selectedAuditLog?.resource_id}
                                                </Text>
                                            }
                                        />}
                                    </SurfaceCard>
                                </Col>

                                {/* ACTION DESCRIPTION */}
                                <Col span={24}>
                                    <SurfaceCard
                                        bg="linear-gradient(135deg, #f6ffed, #f0fff0)"
                                        border="1px solid #b7eb8f"
                                    >
                                        <SectionTitle
                                            icon={<FileSearchOutlined />}
                                            title="Action Description"
                                        />
                                        <Divider />

                                        <Text>{selectedAuditLog.description}</Text>
                                    </SurfaceCard>
                                </Col>

                                {/* CHANGES */}
                                <Col span={24}>
                                    <SurfaceCard
                                        bg="linear-gradient(135deg, #fff0f6, #fff7fb)"
                                        border="1px solid #ffadd2"
                                    >
                                        <SectionTitle
                                            icon={<EditOutlined />}
                                            title="Changes"
                                        />
                                        <Divider />

                                        {selectedAuditLog.changes ? (
                                            <Space direction="vertical" size={14} style={{ width: "100%" }}>
                                                {Object.entries(selectedAuditLog.changes).map(([key, value]) => {
                                                    const isModules = key === "modules";
                                                    const displayKey = isModules ? "Module Permissions" : key;

                                                    return (
                                                        <div
                                                            key={key}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                padding: "12px 16px",
                                                                borderRadius: 12,
                                                                background: "#ffffff",
                                                                border: "1px solid #f0f0f0",
                                                            }}
                                                        >
                                                            {/* LEFT SIDE (LABEL) */}
                                                            <Text strong style={{ textTransform: "capitalize" }}>
                                                                {displayKey} :
                                                            </Text>

                                                            {/* RIGHT SIDE (VALUE / ACTION) */}
                                                            {isModules ? (
                                                                <Button
                                                                    type="primary"
                                                                    icon={<EyeOutlined />}
                                                                    onClick={() => {
                                                                        setSelectedModules({
                                                                            module_permissions: value
                                                                        });
                                                                        setRoleModalVisible(true);
                                                                    }}
                                                                    style={{
                                                                        borderRadius: 999,
                                                                        fontWeight: 500,
                                                                    }}
                                                                >
                                                                    View
                                                                </Button>
                                                            ) : (
                                                                <Text
                                                                    style={{
                                                                        maxWidth: "60%",
                                                                        textAlign: "right",
                                                                        color: "#555",
                                                                        wordBreak: "break-word",
                                                                    }}
                                                                >
                                                                    {typeof value === "object"
                                                                        ? JSON.stringify(value)
                                                                        : value?.toString()}
                                                                </Text>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </Space>
                                        ) : (
                                            <Text type="secondary">No changes</Text>
                                        )}
                                    </SurfaceCard>
                                </Col>
                                {/* TECHNICAL DETAILS */}
                                <Col span={24}>
                                    <SurfaceCard
                                        bg="linear-gradient(135deg, #f9f0ff, #f6f0ff)"
                                        border="1px solid #d3adf7"
                                    >
                                        <SectionTitle
                                            icon={<GlobalOutlined />}
                                            title="Technical Details"
                                        />
                                        <Divider />

                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <InfoItem
                                                    label="IP Address"
                                                    value={
                                                        <Text code>
                                                            {selectedAuditLog.ip_address}
                                                        </Text>
                                                    }
                                                />
                                            </Col>

                                            <Col span={12}>
                                                <InfoItem
                                                    label="HTTP Method"
                                                    value={
                                                        <Tag color="purple">
                                                            {selectedAuditLog.http_method}
                                                        </Tag>
                                                    }
                                                />
                                            </Col>

                                            <Col span={24}>
                                                <InfoItem
                                                    label="Endpoint"
                                                    value={
                                                        <Text code>
                                                            {selectedAuditLog.endpoint}
                                                        </Text>
                                                    }
                                                />
                                            </Col>

                                            <Col span={24}>
                                                <InfoItem
                                                    label="User Agent"
                                                    value={
                                                        <Text style={{ wordBreak: "break-all" }}>
                                                            {selectedAuditLog.user_agent}
                                                        </Text>
                                                    }
                                                />
                                            </Col>

                                            <Col span={24}>
                                                <InfoItem
                                                    label="Created At"
                                                    value={moment(
                                                        selectedAuditLog.created_at
                                                    ).format("DD MMM YYYY, hh:mm A")}
                                                />
                                            </Col>
                                        </Row>
                                    </SurfaceCard>
                                </Col>
                            </Row>
                        </div>

                        {/* FOOTER */}
                        <div
                            style={{
                                padding: 16,
                                textAlign: "right",
                                borderTop: "1px solid #eee",
                                background: "#fff",
                            }}
                        >
                            <Button onClick={() => setViewModal(false)}>
                                Close
                            </Button>
                        </div>
                    </>
                )}
            </Modal>
            <RolePermissionsModal
                open={roleModalVisible}
                role={selectedModules}
                onClose={() => {
                    setSelectedModules({});
                    setRoleModalVisible(false);
                }}
            />
        </div >
    );
}



const RolePermissionsModal = ({ open, role, onClose }) => {
    const PermissionTag = ({ label, enabled }) => (
        <Tag
            icon={enabled ? <CheckOutlined /> : <CloseOutlined />}
            style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "6px 14px",
                fontSize: 13,
                borderRadius: 20,
                border: "none",
                fontWeight: 500,
                background: enabled
                    ? "linear-gradient(135deg, #22c55e, #16a34a)"
                    : "#e5e7eb",
                color: enabled ? "#fff" : "#6b7280",
                pointerEvents: "none", // ✅ view-only
            }}
        >
            {PERMISSION_ICONS[label]} {label}
        </Tag>
    );

    return (
        <Modal
            open={open}
            onCancel={onClose}
            // closable={false}
            zIndex={2000}

            footer={
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        type="primary"
                        size="large"
                        onClick={onClose}
                        style={{
                            minWidth: 110,
                            borderRadius: 999,
                            fontWeight: 600,
                            background: "#003a7a",
                            borderColor: "#003a7a",
                        }}
                    >
                        Done
                    </Button>
                </div>
            }
            width={900}
            centered
        >
            <div style={{ padding: 20 }}>
                <Row gutter={[16, 16]}>
                    {role?.module_permissions?.map((perm, index) => (
                        <Col span={24} md={12} key={perm.module_slug || index}>
                            <Card
                                bordered={false}
                                style={{
                                    borderRadius: 18,
                                    border: "1px solid #e2e8f0",
                                    cursor: "default", // ✅ no click
                                }}
                            >
                                {/* Header */}
                                <Space align="start" size={14}>
                                    <Avatar
                                        style={{
                                            background:
                                                "linear-gradient(135deg, #2563eb, #3b82f6)",
                                        }}
                                    >
                                        {perm?.module_name?.charAt(0)}
                                    </Avatar>

                                    <div>
                                        <Title level={5} style={{ margin: 0 }}>
                                            {perm?.module_name}
                                        </Title>
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            {perm?.module_slug}
                                        </Text>
                                    </div>
                                </Space>

                                <Divider />

                                {/* Permissions */}
                                <Space wrap>
                                    <PermissionTag label="View" enabled={perm?.can_view} />
                                    <PermissionTag label="Create" enabled={perm?.can_create} />
                                    <PermissionTag label="Edit" enabled={perm?.can_edit} />
                                    <PermissionTag label="Delete" enabled={perm?.can_delete} />
                                </Space>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </Modal>
    );
};




export default AuditLogsManager;